import script from "./Pay.vue?vue&type=script&setup=true&lang=js"
export * from "./Pay.vue?vue&type=script&setup=true&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=1e9c4f02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9c4f02"]])

export default __exports__